import {
  IStatusConfigItem,
  RevokeApplicationStatus,
  SubmitApplicationStatus,
  TSortFieldMap,
} from './types.ts';

export const DEFAULT_PERSONAL_DATA_TABLE_PAGINATION = { page: 0, size: 50 };

export const OBJECT_URL_REVOKE_DELAY_MS = 60_000;

export const HIDDEN_FIELD_TOOLTIP =
  'Дані приховані, тому, що ви не являєтесь ініціатором';

export const SUBMIT_SORT_FIELD_MAP: TSortFieldMap = {
  email: 'email',
  phone: 'phone',
  identificationNumber: 'identificationNumber',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  initiatedByFullName: 'initiatedByFullName',
};

export const REVOKE_SORT_FIELD_MAP: TSortFieldMap = {
  identificationNumber: 'identificationNumber',
  createdAt: 'createdAt',
  initiatedByFullName: 'initiatedByFullName',
};

export const SUBMIT_STATUS_CONFIG: Record<SubmitApplicationStatus, IStatusConfigItem> = {
  [SubmitApplicationStatus.SENT]: {
    text: 'Відправлено',
    tooltip: 'Лист відправлено клієнту',
  },
  [SubmitApplicationStatus.VERIFIED]: {
    text: 'Верифіковано',
    tooltip: 'Клієнт пройшов DIA верифікацію',
  },
  [SubmitApplicationStatus.EXPIRED]: {
    text: 'Прострочено',
    tooltip: 'Не підписано, термін дії посилання закінчився',
  },
  [SubmitApplicationStatus.DENIED]: {
    text: 'Відхилено',
    tooltip: 'Клієнт відмовився від підписання',
  },
  [SubmitApplicationStatus.ACCEPTED]: {
    text: 'Підписано',
    tooltip: 'Клієнт підписав заяву',
  },
};

export const REVOKE_STATUS_CONFIG: Record<RevokeApplicationStatus, IStatusConfigItem> = {
  [RevokeApplicationStatus.NEW]: {
    text: 'Створено',
    tooltip: 'Клієнт створив заявку, яка ще пуста',
  },
  [RevokeApplicationStatus.VERIFIED]: {
    text: 'Верифіковано',
    tooltip: 'Клієнт пройшов DIA верифікацію',
  },
  [RevokeApplicationStatus.PENDING]: {
    text: 'Очікує обробки',
    tooltip: 'Клієнт підписав заяву та очікує дії від банку',
  },
  [RevokeApplicationStatus.EXPIRED]: {
    text: 'Прострочено',
    tooltip: 'Клієнт створив посилання та не підписав заяву',
  },
  [RevokeApplicationStatus.COMPLETED]: {
    text: 'Завершено',
    tooltip: 'Заяву завершено',
  },
};
